@if (faqAuthenticationDS$ | async; as faqAuthenticationDS) {
  @if (!faqAuthenticationDS.error && !faqAuthenticationDS.loading) {
    <div class="favorite-container" *transloco="let t; read: 'FAQ_COMPONENT'">
      <div class="searchbar mt-16">
        <ion-searchbar [placeholder]="t('SEARCH')" [debounce]="500" [formControl]="searchBarCtrl"></ion-searchbar>
      </div>
      <div *transloco="let t; read: 'FAQ_COMPONENT'">
        <ng-container *ngLet="faqAuthenticationDS.data | faqFilter: searchBarCtrl.value as categoriesFiltered">
          <div *ngFor="let category of categoriesFiltered">
            <h3 *ngIf="category.questions.length > 0" class="list-category">{{ category.name }}</h3>
            <div class="card-compact-list grid-desktop">
              <div class="card" *ngFor="let faqQuestion of category.questions" (click)="faqQuestion.showAnswer = !faqQuestion.showAnswer">
                <div class="question">
                  <div class="show-more">
                    <ion-icon slot="icon-only" [name]="faqQuestion.showAnswer ? 'remove-outline' : 'add-outline'"></ion-icon>
                  </div>
                  <div class="title" [innerHTML]="faqQuestion.question"></div>
                </div>
                <div *ngIf="faqQuestion.showAnswer" class="answer" [innerHTML]="faqQuestion.answer"></div>
              </div>
            </div>
          </div>
          <div *ngIf="isEmpty(categoriesFiltered)" class="mt-16 flex flex-center">
            {{ t('NO_DATA') }}
          </div>
        </ng-container>
      </div>
    </div>
  }
}
